import { render, staticRenderFns } from "./AutoTags.vue?vue&type=template&id=fb85f770&"
import script from "./AutoTags.vue?vue&type=script&lang=js&"
export * from "./AutoTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports